
import Hero from './components/Hero';
import Problem from './components/Problem';
import FirelineSystem from './components/FirelineSystem';
import WhyDailyEmails from './components/WhyDailyEmails';
import SampleEmails from './components/SampleEmails';
import EmailInAction from './components/EmailInAction';
import WhoThisIsFor from './components/WhoThisIsFor';
import ExclusiveMarket from './components/ExclusiveMarket';
import Pricing from './components/Pricing';
import FinalCTA from './components/FinalCTA';
import Navigation from './components/Navigation';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <Problem />
      <FirelineSystem />
      <WhyDailyEmails />
      <SampleEmails />
      <EmailInAction />
      <WhoThisIsFor />
      <ExclusiveMarket />
      <Pricing />
      <FinalCTA />
      <Footer />
    </div>
  );
}
